import type { RoutesTreeItem } from 'containers/App/Routes/RoutesTreeItem';
import { createTableApiScopeRequirement } from 'utils/rbac/helpers/createTableApiScopeRequirement';

import { NotFoundPage } from 'pages/NotFoundPage/NotFoundPage';
import {
  NetworkAnalysisReportPage,
  networkAnalysisReportApiEndpoint,
} from './NetworkAnalysisReport/NetworkAnalysisReport';
import {
  SiteLowLevelDesignPage,
  siteLowLevelDesignApiEndpoint,
} from './SiteLowLevelDesign/SiteLowLevelDesign';

export const reportsRoutes: RoutesTreeItem[] = [
  {
    path: '/reports/network-analysis-report',
    element: <NetworkAnalysisReportPage />,
    apiEndpoint: networkAnalysisReportApiEndpoint,
    requiredApiScope: createTableApiScopeRequirement(
      networkAnalysisReportApiEndpoint,
    ),
  },
  {
    path: '/reports/site-low-level-design',
    element: <SiteLowLevelDesignPage />,
    apiEndpoint: siteLowLevelDesignApiEndpoint,
    requiredApiScope: createTableApiScopeRequirement(
      siteLowLevelDesignApiEndpoint,
    ),
  },
  {
    path: '/reports/:notfound',
    element: <NotFoundPage />,
  },
];
